import { render, staticRenderFns } from "./VendorList.vue?vue&type=template&id=571ff3ba&scoped=true"
import script from "./VendorList.vue?vue&type=script&lang=js"
export * from "./VendorList.vue?vue&type=script&lang=js"
import style0 from "./VendorList.vue?vue&type=style&index=0&id=571ff3ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571ff3ba",
  null
  
)

export default component.exports